import type { TransientInputFile } from "./formatJobResults";

export const OTHER_FILES_GROUP = "__other_files__";

const DISPLAY_FOLDER_LAYERS = 3;
const USER_SCHEDULES_FOLDER = "user_schedules";

export const formatInputFolderLabel = (folderName: string) => {
  const parts = folderName.split("/").filter(Boolean);
  return parts.slice(-DISPLAY_FOLDER_LAYERS).join("/");
};

const isUserScheduleFile = (relativePath: string) =>
  relativePath.split("/").some((segment) => segment.toLowerCase() === USER_SCHEDULES_FOLDER);

export type TransientInputFileGroup = {
  files: TransientInputFile[];
  folderName: string;
};

export const groupInputFiles = (files: TransientInputFile[]): TransientInputFileGroup[] => {
  const scheduleFolders = new Map<string, TransientInputFile[]>();
  const otherFiles: TransientInputFile[] = [];

  files.forEach((file) => {
    if (!isUserScheduleFile(file.relativePath)) {
      otherFiles.push(file);
      return;
    }
    const folderName = file.relativePath.split("/").filter(Boolean).slice(0, -1).join("/");
    const group = scheduleFolders.get(folderName) ?? [];
    group.push(file);
    scheduleFolders.set(folderName, group);
  });

  const groups = [...scheduleFolders.entries()]
    .map(([folderName, groupFiles]) => ({
      files: groupFiles.slice().sort((a, b) => a.name.localeCompare(b.name)),
      folderName,
    }))
    .sort((a, b) => a.folderName.localeCompare(b.folderName));

  if (otherFiles.length === 0) return groups;
  return [
    {
      files: otherFiles.slice().sort((a, b) => a.name.localeCompare(b.name)),
      folderName: OTHER_FILES_GROUP,
    },
    ...groups,
  ];
};
